module.exports = __webpack_public_path__ + "img/btn-icon-6.c4159843.png";